import { Chart as ChartInstance } from 'react-chartjs-2';

export function usePluginForChart(isGrafTypeLine, isCandleType) {
  return [
    {
      beforeRender(chart) {
        if (isGrafTypeLine) {
          const dataset = chart.data.datasets[0];
          const gradient = chart.ctx.createLinearGradient(
            0,
            0,
            0,
            chart.height ? chart.height - 40 : 0,
          );
          gradient.addColorStop(0, 'rgba(119, 177, 255, 0.7)');
          gradient.addColorStop(1, 'rgba(255, 255, 255, 0.5)');
          const model =
            chart.data.datasets[0]._meta[Object.keys(dataset._meta)[0]].$filler
              .el._model;
          model.backgroundColor = gradient;
        }

        const { optionsToolTip } = chart.data;
        // eslint-disable-next-line no-param-reassign
        chart.pluginTooltips = [];
        if (isCandleType || isGrafTypeLine) {
          if (optionsToolTip && optionsToolTip.length > 0) {
            for (let i = 0; i < optionsToolTip.length; i++) {
              for (let k = 0; k < optionsToolTip[i][0].length; k++) {
                if (
                  optionsToolTip[i][0].length > 0 &&
                  optionsToolTip[i][0][k] &&
                  optionsToolTip[i][0][k].keepTooltipOpen
                ) {
                  chart.pluginTooltips.push(
                    new ChartInstance.Tooltip(
                      {
                        _chart: chart.chart,
                        _chartInstance: chart,
                        _data: chart.data,
                        _options: chart.options.tooltips,
                        _active: [chart.getDatasetMeta(i).data[k]],
                      },
                      chart,
                    ),
                  );
                }
              }
            }
          }
        } else {
          for (let i = 0; i < optionsToolTip.length; i++) {
            if (optionsToolTip[i].keepTooltipOpen) {
              chart.pluginTooltips.push(
                new ChartInstance.Tooltip(
                  {
                    _chart: chart.chart,
                    _chartInstance: chart,
                    _data: chart.data,
                    _options: chart.options.tooltips,
                    _active: [chart.getDatasetMeta(0).data[i]],
                  },
                  chart,
                ),
              );
            }
          }
        }
      },
      ...(isGrafTypeLine && {
        afterDraw(chart) {
          if (chart.tooltip._active && chart.tooltip._active.length) {
            const activePoint = chart.controller.tooltip._active[0];
            const { ctx } = chart;
            const { x, y } = activePoint.tooltipPosition();
            const topY = y;
            const bottomY = chart.scales['right-y-axis'].bottom;

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, topY);
            ctx.lineTo(x, bottomY);
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#e5e5e5';
            ctx.stroke();
            ctx.restore();
          }
        },
      }),

      afterDatasetsDraw(chart, easing) {
        ChartInstance.helpers.each(chart.pluginTooltips, tooltip => {
          tooltip.initialize();
          tooltip.update();
          tooltip.pivot();
          tooltip.transition(easing).draw();
        });
      },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/usePluginForChart.js